<zbp-zbchart-report-table
  reportLabel="Benchmark Standards Over Time Table"
  [leftHeaderText]="'Unit'"
  [rightHeaderText]="'Averages'"
  [zbChart]="zbChart"
  [printableReportHeadings]="printableReportHeadings"
  [isPrinting]="isPrinting"
  [showProgressReportsHelp]="false"
  [useFrontEndPagination]="true"
/>
